"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var httpClient_1 = require("./httpClient");
var apiRoutes_1 = require("../constants/apiRoutes");
var paymentApi = {
    verifyAccessCode: function (transactionToken) {
        return httpClient_1.default.post(apiRoutes_1.default.PAYMENT_VERIFY_PATH, transactionToken);
    },
    getAccessCode: function () { return httpClient_1.default.post(apiRoutes_1.default.PAYMENT_ACCESS_CODE_PATH, {}); },
};
exports.default = paymentApi;
